module.exports = __webpack_public_path__ + "img/support-app.39d9d45f.svg";